<template>
<div class="modal fade" id="bornModal"  tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog ">
		<div class="modal-content ">
			<div class="modal-body ">
				<button type="button" class="btn-close" data-bs-dismiss="modal"  id="bornModalCloseBTN"></button>
				<h2 class="text-center my-text mb-2 " style="font-size:18px" >تاریخ تولد</h2> 
				<small class="d-block text-center mb-2" >روز تولدت از ما یه هدیه ارزشمند دریافت کن.</small>
				<small class="d-block text-center mb-2" >این گزینه قابل ویرایش نیست لطفا در انتخابتان دقت نمایید.</small>
				<form class="w-full d-flex jc-between">
					<div>
						<div class="select-none text-body-1 mb-2 color-700 text-center my-text">روز</div>
						<div class="pos-relative">
						<!-- <input type="hidden" name="bDay" value=""> -->
							<select class="form-select scroll-example my-form-select" aria-label="Default select example" v-model="selected.day">
									<!-- <option selected value="-">روز</option> -->
									<option value='01'>{{PersianNumber('01')}}</option>
									<option value='02'>{{PersianNumber('02')}}</option>
									<option value='03'>{{PersianNumber('03')}}</option>
									<option value='04'>{{PersianNumber('04')}}</option>
									<option value='05'>{{PersianNumber('05')}}</option>
									<option value='06'>{{PersianNumber('06')}}</option>
									<option value='07'>{{PersianNumber('07')}}</option>
									<option value='08'>{{PersianNumber('08')}}</option>
									<option value='09'>{{PersianNumber('09')}}</option>
									<option value='10'>{{PersianNumber('10')}}</option>
									<option value='11'>{{PersianNumber('11')}}</option>
									<option value='12'>{{PersianNumber('12')}}</option>
									<option value='13'>{{PersianNumber('13')}}</option>
									<option value='14'>{{PersianNumber('14')}}</option>
									<option value='15'>{{PersianNumber('15')}}</option>
									<option value='16'>{{PersianNumber('16')}}</option>
									<option value='17'>{{PersianNumber('17')}}</option>
									<option value='18'>{{PersianNumber('18')}}</option>
									<option value='19'>{{PersianNumber('19')}}</option>
									<option value='20'>{{PersianNumber('20')}}</option>
									<option value='21'>{{PersianNumber('21')}}</option>
									<option value='22'>{{PersianNumber('22')}}</option>
									<option value='23'>{{PersianNumber('23')}}</option>
									<option value='24'>{{PersianNumber('24')}}</option>
									<option value='25'>{{PersianNumber('25')}}</option>
									<option value='26'>{{PersianNumber('26')}}</option>
									<option value='27'>{{PersianNumber('27')}}</option>
									<option value='28'>{{PersianNumber('28')}}</option>
									<option value='29'>{{PersianNumber('29')}}</option>
									<option value='30'>{{PersianNumber('30')}}</option>
									<option value='31'>{{PersianNumber('31')}}</option>
							</select>
						</div>
					</div>
					<div>
						<div class="select-none text-body-1 mb-2 color-700 text-center my-text">ماه</div>
						<div class="pos-relative">
						<!-- <input type="hidden" name="bMonth" value=""> -->
							<select class="form-select scroll-example pr-2" style="background-position: left 0.75rem center ;" aria-label="Default select example" v-model="selected.month">
									<!-- <option selected value="-">ماه</option> -->
									<option value="01">فروردین</option>
									<option value="02">اردیبهشت</option>
									<option value="03">خرداد</option>
									<option value="04">تیر</option>
									<option value="05">مرداد</option>
									<option value="06">شهریور</option>
									<option value="07">مهر</option>
									<option value="08">آبان</option>
									<option value="09">آذر</option>
									<option value="10">دی</option>
									<option value="11">بهمن</option>
									<option value="12">اسفند</option>
							</select>
						</div>
					</div>
					<div>
						<div class="select-none text-body-1 mb-2 color-700 text-center my-text">سال</div>
						<div class="pos-relative">
						<!-- <input type="hidden" name="bYear" value=""> -->
							<select class="form-select scroll-example my-form-select" aria-label="Default select example" v-model="selected.year">
								<!-- <option selected value="-">سال</option> -->
								<option value="1335">{{PersianNumber('1335')}}</option>
								<option value="1336">{{PersianNumber('1336')}}</option>
								<option value="1337">{{PersianNumber('1337')}}</option>
								<option value="1338">{{PersianNumber('1338')}}</option>
								<option value="1339">{{PersianNumber('1339')}}</option>
								<option value="1340">{{PersianNumber('1340')}}</option>
								<option value="1341">{{PersianNumber('1341')}}</option>
								<option value="1342">{{PersianNumber('1342')}}</option>
								<option value="1343">{{PersianNumber('1343')}}</option>
								<option value="1344">{{PersianNumber('1344')}}</option>
								<option value="1345">{{PersianNumber('1345')}}</option>
								<option value="1346">{{PersianNumber('1346')}}</option>
								<option value="1347">{{PersianNumber('1347')}}</option>
								<option value="1348">{{PersianNumber('1348')}}</option>
								<option value="1349">{{PersianNumber('1349')}}</option>
								<option value="1350">{{PersianNumber('1350')}}</option>
								<option value="1351">{{PersianNumber('1351')}}</option>
								<option value="1352">{{PersianNumber('1352')}}</option>
								<option value="1353">{{PersianNumber('1353')}}</option>
								<option value="1354">{{PersianNumber('1354')}}</option>
								<option value="1355">{{PersianNumber('1355')}}</option>
								<option value="1356">{{PersianNumber('1356')}}</option>
								<option value="1357">{{PersianNumber('1357')}}</option>
								<option value="1358">{{PersianNumber('1358')}}</option>
								<option value="1359">{{PersianNumber('1359')}}</option>
								<option value="1360">{{PersianNumber('1360')}}</option>
								<option value="1361">{{PersianNumber('1361')}}</option>
								<option value="1362">{{PersianNumber('1362')}}</option>
								<option value="1363">{{PersianNumber('1363')}}</option>
								<option value="1364">{{PersianNumber('1364')}}</option>
								<option value="1365">{{PersianNumber('1365')}}</option>
								<option value="1366">{{PersianNumber('1366')}}</option>
								<option value="1367">{{PersianNumber('1367')}}</option>
								<option value="1368">{{PersianNumber('1368')}}</option>
								<option value="1369">{{PersianNumber('1369')}}</option>
								<option value="1370">{{PersianNumber('1370')}}</option>
								<option value="1371">{{PersianNumber('1371')}}</option>
								<option value="1372">{{PersianNumber('1372')}}</option>
								<option value="1373">{{PersianNumber('1373')}}</option>
								<option value="1374">{{PersianNumber('1374')}}</option>
								<option value="1375">{{PersianNumber('1375')}}</option>
								<option value="1376">{{PersianNumber('1376')}}</option>
								<option value="1377">{{PersianNumber('1377')}}</option>
								<option value="1378">{{PersianNumber('1378')}}</option>
								<option value="1379">{{PersianNumber('1379')}}</option>
								<option value="1380">{{PersianNumber('1380')}}</option>
								<option value="1381">{{PersianNumber('1381')}}</option>
								<option value="1382">{{PersianNumber('1382')}}</option>
								<option value="1383">{{PersianNumber('1383')}}</option>
								<option value="1384">{{PersianNumber('1384')}}</option>
								<option value="1385">{{PersianNumber('1385')}}</option>
								<option value="1386">{{PersianNumber('1386')}}</option>
								<option value="1387">{{PersianNumber('1387')}}</option>
										<option value="1388">{{PersianNumber('1388')}}</option>
										<option value="1389">{{PersianNumber('1389')}}</option>
										<option value="1390">{{PersianNumber('1390')}}</option>
										<option value="1391">{{PersianNumber('1391')}}</option>
										<option value="1392">{{PersianNumber('1392')}}</option>
										<option value="1393">{{PersianNumber('1393')}}</option>
										<option value="1394">{{PersianNumber('1394')}}</option>
										<option value="1395">{{PersianNumber('1395')}}</option>
										<option value="1396">{{PersianNumber('1396')}}</option>
										<option value="1397">{{PersianNumber('1397')}}</option>
										<option value="1398">{{PersianNumber('1398')}}</option>
										<option value="1399">{{PersianNumber('1399')}}</option>	
										<option value="1400">{{PersianNumber('1400')}}</option>	
										<option value="1401">{{PersianNumber('1401')}}</option>		
									</select>
								</div>
							</div>
						</form>
						<div class="mt-4">
							<button class="btn btn-success w-100" @click="setBorn">ثبت تاریخ تولد</button>
						</div>
			</div>
		</div>
	</div>
</div>
</template>

<script setup>
import axios from 'axios';
import { reactive,ref } from 'vue';
import { alertBox } from '@/composables/silverBox';
let userMobile = ref()
let selected = reactive({
	day : '',
	month : '',
	year : '' 	 
})
function setBorn(){
	if(selected.day == ''){
		alert('لطفا روز را انتخاب نمایید')
	}else if(selected.month == ''){
		alert('لطفا ماه را انتخاب نمایید')
	}else if(selected.year == ''){
		alert('لطفا سال را انتخاب نمایید')
	}else{
		userMobile.value = JSON.parse(localStorage.getItem('userInfo'))[0]['mobile'];
		axios
		.get('https://radap.ir/Backend/api/account/profile/setBorn.php?day='+selected.day+'&month='+selected.month+'&year='+selected.year+'&mobile='+userMobile.value)
		.then(()=>{
			// location.reload()
			setTimeout(() => {document.getElementById('bornModalCloseBTN').click()}, 1000);
			alertBox("تاریخ تولد شما با موفقیت تغییر کرد.",'success')
			
		})
	}
}
function PersianNumber(t){for(t=t.toString();t.search("0")>-1;)t=t.replace("0","۰");for(;t.search("1")>-1;)t=t.replace("1","۱");for(;t.search("2")>-1;)t=t.replace("2","۲");for(;t.search("3")>-1;)t=t.replace("3","۳");for(;t.search("4")>-1;)t=t.replace("4","۴");for(;t.search("5")>-1;)t=t.replace("5","۵");for(;t.search("6")>-1;)t=t.replace("6","۶");for(;t.search("7")>-1;)t=t.replace("7","۷");for(;t.search("8")>-1;)t=t.replace("8","۸");for(;t.search("9")>-1;)t=t.replace("9","۹");return t}
</script>

<style scoped>
.w-full {
    width: 100%;
}
.ModalLayout_ModalLayout__children__8xGgg>* {
    flex-grow: 1;
}
.gap-5 {
    grid-gap: calc(5 * var(--spacing-base));
    gap: calc(5 * var(--spacing-base));
}
.jc-between {
    justify-content: space-between;
}
.color-700 {
    color: var(--color-neutral-700);
}

.text-body-1 {
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 2.15;
}
.pos-relative {
    position: relative;
}
input {
    background-color: transparent;
}
.radius {
    border-radius: var(--global-radius);
}
.bg-100 {
    background-color: var(--color-neutral-100);
}
.h-48 {
    height: 4.8rem;
}
.DropDown_DropDown__list__VFq8Z {
    height: 192px;
}

.DropDown_DropDown__list__VFq8Z {
    height: 192px;
}
.mt-1 {
    margin-top: calc(1 * var(--spacing-base));
}
.user-select-none {
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.hide-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
}
.radius {
    border-radius: var(--global-radius);
}
.border-200 {
    border: 1px solid var(--color-neutral-200);
}
.z-1 {
    z-index: 1;
}
.pos-absolute {
    position: absolute;
}
.bg-000 {
    background-color: var(--color-neutral-000);
}
.overflow-y-auto {
    overflow-y: auto;
}
.overflow-hidden {
    overflow: hidden;
}
.w-100 {
    width: 100%;
}
.color-800 {
    color: var(--color-neutral-800);
}

.text-body-1 {
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 2.15;
}
.px-3 {
    padding-right: calc(3 * var(--spacing-base));
    padding-left: calc(3 * var(--spacing-base));
}
.pointer {
    cursor: pointer;
}
.w-full {
    width: 100%;
}
.ai-center {
    align-items: center;
}
.my-text{
font-size: 16px;
font-weight: 700;

}
 .form-select {
	background: #eee;
}
 .my-form-select option {
	text-align: left;
	direction: ltr;
}
 .form-select option {
	text-align: right;
	direction: rtl;
}
</style>